import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateWebhookMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateWebhookInput;
}>;

export type UpdateWebhookMutationResult = { __typename?: 'Mutation' } & {
  webhookSubscriptionsUpdateWebhook?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateWebhookPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateWebhookDocument = /*#__PURE__*/ gql`
  mutation updateWebhook($input: UpdateWebhookInput!) {
    webhookSubscriptionsUpdateWebhook(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateWebhookMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookMutation, { data, loading, error }] = useUpdateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebhookMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateWebhookMutationResult, UpdateWebhookMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateWebhookMutationResult, UpdateWebhookMutationVariables>(UpdateWebhookDocument, options);
}
export type UpdateWebhookMutationHookResult = ReturnType<typeof useUpdateWebhookMutation>;
